<template>
	<modal :show.sync="syncModal" footerClasses="d-none">
		<form-report-access
			:instance="{ type: 'Corporate Admin' }"
			assign-from="report"
			assign-to="company"
			:company-id="companySvc.company.id"
			:excludes="excludes"
			ref="report_access_form"
		>
			<template #return>
				<base-button
					@click.stop="syncModal = false"
					:disabled="formProcessing"
					type="white"
					size="md"
					class="form-btn font-weight-normal px-0 shadow-none"
					>Cancel</base-button
				>
			</template>
		</form-report-access>

		<template #footer>
			<div class="sr-only"></div>
		</template>
	</modal>
</template>

<script>
import FormReportAccess from "@components/FormReportAccess";

export default {
	name: "company-report-access-modal",
	components: {
		FormReportAccess,
	},
	inject: ["companySvc", "ErrorService", "memberSvc"],
	data() {
		return {
			syncModal: false,
			formProcessing: false,
			excludes: [],
		};
	},
	created() {
		this.$bus.key = "company-report-access-modal";
	},
	computed: {
		params() {
			return "Corporate Admin" === this.memberSvc.member.type
				? { page_size: 1000 }
				: {
						company_id: this.companySvc.company.id,
						assignee: "Corporate Admin",
						page_size: 1000,
				  };
		},
		selected() {
			if (!this.memberSvc.member.reports) return [];

			return this.memberSvc.member.reports.map((item) => {
				return {
					id: item.report_id,
					items: [
						"Corporate Admin" === this.memberSvc.member.type
							? this.companySvc.company.id
							: this.memberSvc.member.id,
					],
					assigned_items: [
						item.report_assigned_id ||
							item.report_assigned_member_id,
					],
				};
			});
		},
	},
	mounted() {
		this.ErrorService.stopProcessingOnFail(this);

		this.$bus.trackEvent("toggle-modal", (payload) => {
			if ("company-report-access" === payload.key)
				this.syncModal = payload.active;
		});

		this.$bus.trackEvent("datatable-items-fetched", (payload) => {
			if ("company-report-access-modal" !== this.$bus.key) return false;

			this.excludes = payload.map((item) => item.report_id);
		});

		this.$bus.trackEvent("datatable-item-deleted", (payload) => {
			if ("company-report-access-modal" !== this.$bus.key) return false;

			const index = this.excludes.findIndex(
				(item) => item === payload.report_id
			);

			if (0 <= index) this.excludes.splice(index, 1);
		});

		this.$bus.trackEvent("report-access-assigned", (payload) => {
			if ("company-report-access-modal" !== this.$bus.key) return false;

			const excludes = payload.map((pitem) => pitem.report.id);

			this.excludes = this.excludes.concat(excludes);
		});

		this.$bus.trackEvent("report-access-form-processing", (payload) => {
			this.syncModal = payload;
			this.formProcessing = payload;
		});
	},
};
</script>
